



















import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  MiscellaneousComparisonTitleDetails,
  MonthComparisonTitleDetails,
  SummaryAnalysisOutput,
} from '@/models/swine/analysis.model';
import AnalysisLayout from '@/components/swine/layout/AnalysisLayout.vue';
import BarAndLineChart from '@/components/swine/reports/BarAndLineChart.vue';
import PleurisyTable from './PleurisyTable.vue';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
import {
  PLEURISY_SCORE_COLORS,
  ELANCO_LOGO_IMAGE,
  LUNG_LESION_IMAGE,
  CROSS_PLOT_LOGO,
} from '@/utils/analysisPdfMake';
import { convertDateToDDMMYYYYWithSlashes } from '@/utils/moment';
import { TableCell, TDocumentDefinitions } from 'pdfmake/interfaces';
import { addDecimalPointToNumbers } from '@/utils/formats';
@Component({
  components: {
    AnalysisLayout,
    BarAndLineChart,
    PleurisyTable,
  },
})
export default class PleurisyComponent extends Vue {
  @Prop({})
  chartData!: Chart.ChartData;

  @Prop({})
  options!: Chart.ChartOptions;

  @Prop({})
  analysisResponse!: SummaryAnalysisOutput;

  @Prop({})
  comparisonTitle!: MiscellaneousComparisonTitleDetails &
    MonthComparisonTitleDetails;

  @Prop({ required: true })
  isCurrentRoleViewer!: boolean;

  removeNumberOfLungsExamined = false;

  updateRemoveNumberOfLungsExamined(value: boolean) {
    this.removeNumberOfLungsExamined = value;
  }

  generateChartImage() {
    const currentDocument: HTMLCanvasElement | null = document.getElementById(
      'line-chart',
    ) as HTMLCanvasElement;
    if (currentDocument) {
      return currentDocument.toDataURL();
    }
    return '';
  }

  generatePDFBodyTitle() {
    let generatedTitle = `Comparison of ${this.comparisonTitle.selectedOption} by ${this.comparisonTitle.selectedComparison} from ${this.comparisonTitle.startDate} and ${this.comparisonTitle.endDate} `;
    if (this.comparisonTitle.queries) {
      generatedTitle += `between `;
      this.comparisonTitle.queries.forEach((detail, index) => {
        if (index < this.comparisonTitle.queries.length - 1) {
          generatedTitle += `${detail}, `;
        } else {
          generatedTitle += `and ${detail}.`;
        }
      });
    }

    if (this.comparisonTitle.farmUnitCodeName) {
      generatedTitle += `on ${this.comparisonTitle.farmUnitCodeName}.`;
    }

    return generatedTitle;
  }

  generatePDFTableHeader(): TableCell[] {
    return [
      {
        text: '',
        fillColor: PLEURISY_SCORE_COLORS.LIGHT_GREY.BACKGROUND,
        color: PLEURISY_SCORE_COLORS.LIGHT_GREY.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
        alignment: `center`,
        marginTop: 15,
      },
      {
        text: 'No. of Lungs Examined',
        fillColor: PLEURISY_SCORE_COLORS.DARK_GREY.BACKGROUND,
        color: PLEURISY_SCORE_COLORS.DARK_GREY.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
        alignment: `center`,
        marginTop: 15,
      },
      {
        text: 'Pleuritis 0 (%)',
        fillColor: PLEURISY_SCORE_COLORS.GREEN.BACKGROUND,
        color: PLEURISY_SCORE_COLORS.LIGHT_GREY.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
        alignment: `center`,
        marginTop: 15,
      },
      {
        text: 'Pleuritis 1 (%)',
        fillColor: PLEURISY_SCORE_COLORS.YELLOW_LIGHT.BACKGROUND,
        color: PLEURISY_SCORE_COLORS.YELLOW_LIGHT.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
        alignment: `center`,
        marginTop: 15,
      },
      {
        text: 'Pleuritis 2 (%)',
        fillColor: PLEURISY_SCORE_COLORS.RED_LIGHT.BACKGROUND,
        color: PLEURISY_SCORE_COLORS.RED_LIGHT.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
        alignment: `center`,
        marginTop: 15,
      },
      {
        text: 'Pleuritis 3 (%)',
        fillColor: PLEURISY_SCORE_COLORS.RED.BACKGROUND,
        color: PLEURISY_SCORE_COLORS.RED.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
        alignment: `center`,
        marginTop: 15,
      },
      {
        text: 'Pleuritis 4 (%)',
        fillColor: PLEURISY_SCORE_COLORS.RED_DARK.BACKGROUND,
        color: PLEURISY_SCORE_COLORS.RED_DARK.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
        alignment: `center`,
        marginTop: 15,
      },
      {
        fillColor: PLEURISY_SCORE_COLORS.WHITE.BACKGROUND,
        color: PLEURISY_SCORE_COLORS.WHITE.TEXT,
        border: [false, false, false, true],
        alignment: `center`,
        table: {
          body: [
            [
              {
                svg: CROSS_PLOT_LOGO,
                alignment: `center`,
                border: [false, false, false, false],
                fillColor: PLEURISY_SCORE_COLORS.WHITE.BACKGROUND,
                color: PLEURISY_SCORE_COLORS.WHITE.TEXT,
                fontSize: 9,
                bold: true,
              },
            ],
            [
              {
                text: 'Pleurisy Prevalence(%)',
                fillColor: PLEURISY_SCORE_COLORS.WHITE.BACKGROUND,
                color: PLEURISY_SCORE_COLORS.WHITE.TEXT,
                fontSize: 9,
                border: [false, false, false, false],
                bold: true,
                alignment: `center`,
              },
            ],
          ],
        },
      },
    ];
  }

  generatePDFTableContent(): TableCell[][] {
    if (this.analysisResponse) {
      const tableData = [];
      if (this.analysisResponse.farmUnits) {
        tableData.push(...this.analysisResponse.farmUnits);
      }
      if (this.analysisResponse.industryAverages) {
        tableData.push(...this.analysisResponse.industryAverages);
      }
      if (this.analysisResponse.individualReports) {
        tableData.push(...this.analysisResponse.individualReports);
      }

      const pdfTableDetails = tableData.map((data) => {
        if (data.pleurisyPercentageDict) {
          return [
            {
              text: data.identifier,
              fillColor: PLEURISY_SCORE_COLORS.LIGHT_GREY.BACKGROUND,
              color: PLEURISY_SCORE_COLORS.LIGHT_GREY.TEXT,
              fontSize: 10,
              border: [false, false, false, true],
              bold: true,
              margin: [3, 3, 0, 3],
            },
            {
              text: data.numberOfLungsExaminedForPleuritis,
              fillColor: PLEURISY_SCORE_COLORS.DARK_GREY.BACKGROUND,
              color: PLEURISY_SCORE_COLORS.DARK_GREY.TEXT,
              fontSize: 10,
              border: [false, false, false, true],
              bold: true,
              alignment: `center`,
              margin: [0, 3, 0, 3],
            },
            {
              text: addDecimalPointToNumbers(data.pleurisyPercentageDict[`P0`]),
              fillColor: PLEURISY_SCORE_COLORS.GREEN.BACKGROUND,
              color: PLEURISY_SCORE_COLORS.LIGHT_GREY.TEXT,
              fontSize: 10,
              border: [false, false, false, true],
              bold: true,
              alignment: `center`,
              margin: [0, 3, 0, 3],
            },
            {
              text: addDecimalPointToNumbers(data.pleurisyPercentageDict[`P1`]),
              fillColor: PLEURISY_SCORE_COLORS.YELLOW_LIGHT.BACKGROUND,
              color: PLEURISY_SCORE_COLORS.YELLOW_LIGHT.TEXT,
              fontSize: 10,
              border: [false, false, false, true],
              bold: true,
              alignment: `center`,
              margin: [0, 3, 0, 3],
            },
            {
              text: addDecimalPointToNumbers(data.pleurisyPercentageDict[`P2`]),
              fillColor: PLEURISY_SCORE_COLORS.RED_LIGHT.BACKGROUND,
              color: PLEURISY_SCORE_COLORS.RED_LIGHT.TEXT,
              fontSize: 10,
              border: [false, false, false, true],
              bold: true,
              alignment: `center`,
              margin: [0, 3, 0, 3],
            },
            {
              text: addDecimalPointToNumbers(data.pleurisyPercentageDict[`P3`]),
              fillColor: PLEURISY_SCORE_COLORS.RED.BACKGROUND,
              color: PLEURISY_SCORE_COLORS.RED.TEXT,
              fontSize: 10,
              border: [false, false, false, true],
              bold: true,
              alignment: `center`,
              margin: [0, 3, 0, 3],
            },
            {
              text: addDecimalPointToNumbers(data.pleurisyPercentageDict[`P4`]),
              fillColor: PLEURISY_SCORE_COLORS.RED_DARK.BACKGROUND,
              color: PLEURISY_SCORE_COLORS.RED_DARK.TEXT,
              fontSize: 10,
              border: [false, false, false, true],
              bold: true,
              alignment: `center`,
              margin: [0, 3, 0, 3],
            },
            {
              text: data.pleurisyPrevalence,
              fillColor: PLEURISY_SCORE_COLORS.WHITE.BACKGROUND,
              color: PLEURISY_SCORE_COLORS.WHITE.TEXT,
              fontSize: 10,
              border: [false, false, false, true],
              bold: true,
              alignment: `center`,
              margin: [0, 3, 0, 3],
            },
          ];
        }
        return [];
      });
      return pdfTableDetails;
    }
    return [[]];
  }

  generatePdfTable() {
    const pdfTable: TableCell[][] = [this.generatePDFTableHeader()];
    const details = this.generatePDFTableContent();

    if (details) {
      details.forEach((item) => {
        if (item) {
          pdfTable.push(item);
        }
      });
    }
    return pdfTable;
  }

  generatePDF() {
    try {
      const imgElancoLogo = ELANCO_LOGO_IMAGE;
      const imgLungLesion = LUNG_LESION_IMAGE;
      const headerTitle = 'Lung Lesion Scoring Analysis';
      pdfMake.tableLayouts = {
        headerLayout: {
          hLineColor: function () {
            return '#dbdbdb';
          },
          vLineColor: function () {
            return '';
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        tableLayout: {
          hLineColor: function () {
            return '#dbdbdb';
          },
          vLineColor: function () {
            return '';
          },
        },
      };

      const docDefinition: TDocumentDefinitions = {
        pageOrientation: 'landscape',
        content: [
          {
            table: {
              widths: ['auto', 'auto', '*'],
              body: [
                [
                  {
                    svg: imgElancoLogo,
                    width: 100,
                    margin: [0, 0, 0, 0],
                    border: [false, false, false, true],
                  },
                  {
                    svg: imgLungLesion,
                    width: 50,
                    margin: [120, 0, 0, 0],
                    border: [false, false, false, true],
                  },
                  {
                    text: headerTitle,
                    color: '#333',
                    bold: true,
                    fontSize: 20,
                    margin: [17, 17, 0, 17],
                    border: [false, false, false, true],
                  },
                ],
              ],
            },
            layout: 'headerLayout',
          },
          {
            text: this.generatePDFBodyTitle(),
            bold: true,
            fontSize: 14,
            margin: [0, 30, 0, 30],
          },
          {
            columns: [
              {
                width: 741,
                image: this.generateChartImage(),
              },
            ],
            pageBreak: 'after',
          },
          {
            table: {
              widths: ['auto', 'auto', '*'],
              body: [
                [
                  {
                    svg: imgElancoLogo,
                    width: 100,
                    margin: [0, 0, 0, 0],
                    border: [false, false, false, true],
                  },
                  {
                    svg: imgLungLesion,
                    width: 50,
                    margin: [120, 0, 0, 0],
                    border: [false, false, false, true],
                  },
                  {
                    text: headerTitle,
                    color: '#333',
                    bold: true,
                    fontSize: 20,
                    margin: [17, 17, 0, 17],
                    border: [false, false, false, true],
                  },
                ],
              ],
            },
            layout: 'headerLayout',
          },
          {
            text: this.generatePDFBodyTitle(),
            bold: true,
            fontSize: 14,
            margin: [0, 30, 0, 30],
          },
          {
            table: {
              widths: ['*', 100, 90, 90, 90, 90, 90, 120],
              body: this.generatePdfTable(),
            },
            layout: 'tableLayout',
          },
        ],
        footer: {
          columns: [
            {
              text: `Exported on ${convertDateToDDMMYYYYWithSlashes(
                new Date(),
              )}`,
              fontSize: 10,
              color: '#8e8e8e',
              margin: [30, 0, 0, 0],
            },
          ],
        },
      };
      pdfMake
        .createPdf(docDefinition)
        .download('lung-lesion-scoring-analysis.pdf');
    } catch (error) {
      console.error(error);
    }
  }
}
